import {
  requests 
} from '../../../api/agent'

export default {
  getAisMvExistSubscribers: (params) => requests.getWithParams('/AisMv/GetAisMvExistSubscribers', params),
  getAisMvBySearch: (params) => requests.getWithParams('/AisMv/GetAisMvBySearch', params),
  createSubscribeAisMv: (params) => requests.post('/AisMv/CreateSubscribeAisMv', params),
  deleteSubscribeAisMv: (params) => requests.post('/AisMv/DeleteSubscribeAisMv', params),
}